/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2021-07-21 14:31:58
 * @LastEditors: zhanghang
 * @LastEditTime: 2022-10-18 17:50:14
 */
import DsfPlatformPolyline from './polyline.vue'
import DsfPlatformBar from './bar.vue'
import DsfPlatformPie from './pie.vue'
import DsfPlatformMixinAxis from './mixinAxis.vue'
import DsfPlatformRadar from './radar.vue'
import DsfPlatformMapChart from './mapChart.vue'
import DsfPlatformScatter from './scatter.vue'
const components = {
  DsfPlatformPolyline,
  DsfPlatformBar,
  DsfPlatformPie,
  DsfPlatformMixinAxis,
  DsfPlatformRadar,
  DsfPlatformMapChart,
  DsfPlatformScatter
}

function install(Vue){
  for (let key in components) {
    let it = components[key];
    Vue.component(it.name, it);
    if (!window.$components['platform']) {
      window.$components['platform'] = {}
    }
    window.$components['platform'][it.name] = it;
  }  
}

export default {
  install
}